import { AppLauncherService } from './app-launcher.service';

export default angular
  .module('sfMobile.services.app-settings', [])
  .service('appLauncherService', AppLauncherService).name;
